import React from 'react'
import { useQuery } from 'react-query'
import ApiClient from 'data/api/api_client'
import Link from 'components/Link'
import Image from 'components/Image'
import classNames from 'classnames'
import Paragraphs from './home/common/typography/Paragraphs'


type Props = {
  slug: string
  timestamp?: string
  className?: {
    container?: string
  }
}

const ArticleMiniAuthor = ({
  slug,
  timestamp,
  className,
}: Props) => {
  const { data: author } = useQuery('author', () => ApiClient.magazine.getAuthor(slug))

  if (!author) {
    return null
  }

  return (
    <div className={classNames('flex gap-10', className?.container)}>
      <Link href={`/magazine/authors/${author.slug}`} className="h-45 w-45">
        <Image
          src={author.profileImage.src}
          className="object-cover object-center rounded-full"
          width={45}
          height={45}
          alt="Author Profile Image"
        />
      </Link>
      <div className="flex flex-col justify-center flex-1">
        <Paragraphs.PublicHeader
          className="font-bold text-left text-grey-800 tracking-1/4"
        >
          By {author.name}
        </Paragraphs.PublicHeader>

        {timestamp && (
          <Paragraphs.PublicHeader className="text-left text-grey-650">
            {timestamp}
          </Paragraphs.PublicHeader>
        )}
      </div>
    </div>
  )
}

export default ArticleMiniAuthor
